export const tableIndexToColumnIndex = (
  index: number,
  length: number,
  visaSummeringar: boolean
) => {
  return visaSummeringar ? index + length - 1 : index;
};

export const columnIndexToTableIndex = (
  index: number,
  length: number,
  visaSummeringar: boolean
) => {
  return visaSummeringar ? index - length + 1 : index;
};
